import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { cardStyle, sectionTitleStyle, sectionTitleText } from "../cardStyles";

interface ProtectionCalculatorCardProps {
  onOpen: () => void;
}

const ProtectionCalculatorCard = ({ onOpen }: ProtectionCalculatorCardProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  return (
    <div style={{ ...cardStyle, border: "1px solid #e0e7ff", position: "relative" }}>
      <span
        style={{
          position: "absolute",
          top: 16,
          right: 16,
          backgroundColor: "#eef2ff",
          color: "#4338ca",
          fontSize: 12,
          fontWeight: 600,
          padding: "3px 12px",
          borderRadius: 20,
        }}
      >
        Beta
      </span>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="CalculatorIcon" size="XS" color="#4f46e5" />
        <h2 style={sectionTitleText}>
          {translate("newDashboard.redesign.protectionCalculator")}
        </h2>
      </div>
      <p style={{ fontSize: 14, color: "#6b7280", margin: "8px 0 20px" }}>
        {translate("newDashboard.redesign.protectionCalculatorDesc")}
      </p>
      <ButtonDS
        label={translate("newDashboard.calculator.openButton")}
        buttonType="primary"
        size="40"
        onClick={onOpen}
      />
    </div>
  );
};

export default ProtectionCalculatorCard;
